import { useBackgroundQuery, type QueryRef } from '@apollo/client/react';
import { useMemo } from 'react';

import { QueryOrderEnum, AppMembershipsOrderByEnum } from 'src/graphql/schema';
import {
  AppMembershipsDocument,
  type IAppMembershipsQuery,
} from 'src/graphql/actions/appMemberships/appMemberships.query';
import { createRequiredContext } from 'src/context/createRequiredContext';

const [useAppMembershipsManagement, AppMembershipsManagementProvider] = createRequiredContext<{
  queryAppMembershipsRef: QueryRef<IAppMembershipsQuery>;
  appId: string;
  canCreateMember: boolean;
}>();

type Props = {
  appId: string;
  canCreateMember: boolean;
};

const AppMembershipsManagementContextProvider = ({
  children,
  appId,
  canCreateMember,
}: React.PropsWithChildren<Props>) => {
  const [queryRef] = useBackgroundQuery(AppMembershipsDocument, {
    variables: {
      appId,
      page: 1,
      perPage: 100,
      orderBy: AppMembershipsOrderByEnum.Role,
      order: QueryOrderEnum.Asc,
    },
  });

  const queryAppMembershipsRef = useMemo(() => queryRef, [queryRef]);

  const values = {
    appId,
    canCreateMember,
    queryAppMembershipsRef,
  };

  return <AppMembershipsManagementProvider value={values}>{children}</AppMembershipsManagementProvider>;
};

export { AppMembershipsManagementContextProvider, useAppMembershipsManagement };
